import { Fragment, type ReactNode } from "react"

const escapeRegExp = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")

/**
 * - matchQueries가 비어있으면 text를 그대로 반환
 * - 쿼리는 길이가 긴 순(부분겹침 완화)로 처리
 */
export const renderTextWithMatchHighlights = (text: string, matchQueries?: string[]) => {
  if (!matchQueries || matchQueries.length === 0) return text

  const sorted = [...matchQueries]
    .map((q) => q.trim())
    .filter((q) => q.length > 0)
    .sort((a, b) => b.length - a.length)

  if (sorted.length === 0) return text

  let nodes: ReactNode = text
  for (const q of sorted) {
    if (typeof nodes === "string" && !nodes.includes(q)) continue
    if (typeof nodes === "string") {
      const parts: string[] = nodes
        .split(new RegExp(`(${escapeRegExp(q)})`, "g"))
        .filter((p): p is string => p.length > 0)
      nodes = parts.map((part: string, i: number) => {
        if (part === q) {
          return <span key={`${q}-${i}`} className="text-primary-700 font-semibold">{part}</span>
        }
        return <Fragment key={`${q}-t-${i}`}>{part}</Fragment>
      })
    } else {
      // 이미 ReactNode로 쪼개진 경우(드문 케이스)에는 추가 하이라이트는 생략(과도한 복잡도 방지)
    }
  }

  return nodes
}
